import { HttpClient } from 'data/protocols/http';
import { GetDashboardChartData } from 'domain/usecases';
import { MetricsPlot } from '@hone-automation/common';

export class RemoteGetDashboardChartData implements GetDashboardChartData {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteGetDashboardChartData.Model>
  ) {}

  async get(params: GetDashboardChartData.Params): Promise<MetricsPlot> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        locationId: params.locationId,
      },
    });

    return httpResponse.body!;
  }
}

export namespace RemoteGetDashboardChartData {
  export type Model = MetricsPlot;
}
